import React from 'react'

const Works = () => {
  return (
    <div className=' h-max bg-[#142d4c] pt-6' id='works'> 
        <h1 className='  text-3xl text-white flex justify-center font-extrabold pt-7'>Projects</h1> 

        <div className=' flex flex-wrap justify-center ml-16 mr-16 gap-x-10'>
        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full  dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full bg-[#0B2447]" src='https://cdn-icons-png.flaticon.com/512/9761/9761145.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Weather Application
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    This Application is responsible for showing all the Weather parameters like Temperature, Weather description, Wind Speed, Humidity, Max and Min Temperatures and Pressure when we search for a City
                </div> 
                <div className=' flex mt-3 justify-evenly'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/8605/8605634.png" alt="" className=' w-5 h-auto ml-3' />


                </div>  
                <a href="https://manishankar-weather-app.netlify.app"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a>
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full   dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full object-cover" src='https://cdn-icons-png.flaticon.com/128/7011/7011353.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Social Media Application
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    This social media application allows users to connect, share, and interact with each other through posts, comments, and likes. Users can create profiles, follow other users, and see updates on their feeds                </div> 
                <div className=' flex mt-3 justify-evenly items-baseline'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png" alt="" className=' w-5 h-auto ml-3 text-white' />
                    <img src="https://cdn.iconscout.com/icon/free/png-256/mongodb-3521676-2945120.png?f=webp&w=256" alt="" className=' w-5 h-auto ml-3 text-white' />


                </div>   
                <a href="https://social-media-client-dusky.vercel.app/login"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full   dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full object-cover" src='https://cdn-icons-png.flaticon.com/128/3153/3153506.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Job Tracker
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    This job tracker application allows users to efficiently manage and organize their job applications in one place. With user authentication, individuals can securely log in and access their personalized dashboard.                 </div> 
                <div className=' flex mt-3 justify-evenly items-baseline'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://i3.wp.com/banner2.cleanpng.com/20190529/uh/kisspng-firebase-cloud-messaging-google-cloud-messaging-ap-5ceed4e7432b70.0924427415591559432751.jpg?ssl=1" alt="" className=' w-5 h-auto ml-3' />
                </div>   
                <a href="https://mani-shankar-job-tracker.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full   dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full object-cover" src='https://cdn-icons-png.flaticon.com/128/7214/7214200.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Dictionary Application
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                This dictionary application allows users to look up word definitions, pronunciations, synonyms, and antonyms using a dictionary API. The intuitive interface provides quick and easy access to detailed word information, including example sentences and word origins.                </div> 
                <div className=' flex mt-3 justify-evenly items-baseline'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://cdn-icons-png.flaticon.com/512/8605/8605634.png" alt="" className=' w-5 h-auto ml-3' />
                </div>   
                <a href="https://mani-shankar-dictionary.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full   dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full object-cover" src='https://cdn-icons-png.flaticon.com/128/681/681803.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        News Application
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    This news application provides users with the latest updates from around the world by leveraging the News API. Users can browse news articles across various categories, such as top stories, most viewed, most emailed, and most shared news.                </div> 
                <div className=' flex mt-3 justify-evenly items-baseline'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://cdn-icons-png.flaticon.com/512/8605/8605634.png" alt="" className=' w-5 h-auto ml-3' />
                </div>   
                <a href="https://manishankar-news-app.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full   dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full object-cover" src='https://cdn-icons-png.flaticon.com/128/1065/1065711.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Recipe Application
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    This recipe application helps users discover and explore a wide range of recipes from various cuisines. By utilizing the Recipe API, users can search for recipes based on ingredients,nutrients cuisine type, or specific dietary needs.                </div> 
                <div className=' flex mt-3 justify-evenly items-baseline'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://cdn-icons-png.flaticon.com/512/8605/8605634.png" alt="" className=' w-5 h-auto ml-3' />
                </div>   
                <a href="https://mani-shankar-recipe-app.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full   dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full object-cover" src='https://cdn-icons-png.flaticon.com/128/2731/2731146.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Image Search App
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    This application allows users to browse and search images.When you search for a image it shows all the images related to the search.
                </div> 
                <div className=' flex mt-3 justify-evenly items-baseline'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/8605/8605634.png" alt="" className=' w-5 h-auto ml-3' />


                </div> 
                <a href="https://manishankar-image-search.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px]  p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full  dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full" src='https://cdn-icons-png.flaticon.com/128/7742/7742546.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Employee Management System
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    This Application simplifies HR tasks. Efficiently add, update, and manage employee data with ease. Streamline HR processes for improved productivity
                </div> 
                <div className=' flex mt-3 justify-evenly items-baseline'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png" alt="" className=' w-5 h-auto ml-3 text-white' />
                    <img src="https://cdn.iconscout.com/icon/free/png-256/mongodb-3521676-2945120.png?f=webp&w=256" alt="" className=' w-5 h-auto ml-3 text-white' />


                </div>  
                <a href="https://manishankar-employee-management-syste.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a>
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full  dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full bg-[#0B2447]" src='https://cdn-icons-png.flaticon.com/128/2786/2786398.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Countries Application
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    Discover fascinating details about every country, from cultural highlights to geographical wonders. Whether you're a traveler planning your next adventure or simply curious about the world, our app offers a comprehensive exploration of countries and their unique characteristics.
                </div> 
                <div className=' flex mt-3 justify-evenly items-end'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/8605/8605634.png" alt="" className=' w-5 h-auto ml-3' />

                </div> 
                <a href="https://manishankar-countries-app.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full bg-[#0B2447]" src='https://cdn-icons-png.flaticon.com/512/9537/9537221.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        TODO Application
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    The MERN stack Todo app with authentication provides a secure and user-friendly platform for managing tasks. Leveraging MongoDB, Express.js, React, and Node.js, the app allows users to create, update, and delete tasks with ease.
                </div> 
                <div className=' flex mt-3 justify-evenly'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png" alt="" className=' w-5 h-auto ml-3 text-white' />
                    <img src="https://cdn.iconscout.com/icon/free/png-256/mongodb-3521676-2945120.png?f=webp&w=256" alt="" className=' w-5 h-auto ml-3 text-white' />


                </div>  
                <a href='https://mani-shankar-advanced-todo-app.netlify.app/'><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a>
            </div>
        </div>

        <div class="flex flex-wrap mt-20 ">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full  dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full bg-[#0B2447]" src='https://cdn-icons-png.flaticon.com/128/6878/6878684.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Movie Search Application 
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200">
                    The application integrates with a movie database API to fetch real-time data, offering users detailed insights into each movie, including cast, synopsis, ratings, and more. A dynamic solution for movie enthusiasts, combining functionality with an engaging user interface. 
                </div> 
                <div className=' flex mt-3 justify-evenly'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/8605/8605634.png" alt="" className=' w-5 h-auto ml-3' />


                </div> 
                <a href="https://manishankarr-movie-search-app.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 
             
            </div>
        </div>

        <div class="flex flex-wrap mt-20">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full bg-[#0B2447]" src='https://cdn-icons-png.flaticon.com/128/1647/1647351.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Blog Application
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200 text-sm">
                    A blog application form is a form that is used to collect information from individuals who are interested in creating a blog on a particular platform.  Additionally, the form may ask for more specific information related to the blog, such as the desired blog title, URL, and a brief description.
                </div> 
                <div className=' flex mt-3 justify-evenly'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg" alt="" className=' w-5 h-auto ml-3' />


                </div>  
                    <a href="https://manishankar-blog-web-app.netlify.app/"><button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Show</button></a> 

            </div>
        </div>

        <div class="flex flex-wrap mt-20">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[97px] items-center justify-center rounded-full  dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full object-cover" src='https://cdn-icons-png.flaticon.com/512/6891/6891211.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Authentication Forms 
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200 text-sm">
                    React application that prioritizes the security of your data. With our JWT-based authentication system, you can confidently manage user access and protect sensitive information. Seamlessly integrate authentication into your React projects, ensuring a smooth and secure user experience.
                </div> 
                <div className=' flex mt-3 justify-evenly'>
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn.worldvectorlogo.com/logos/jwt-3.svg" alt="" className=' w-5 h-auto ml-3 text-white' />

                </div>  
            </div>
        </div>

        <div class="flex flex-wrap mt-20">
            <div class="relative flex flex-col items-center rounded-[20px] w-[330px] mx-auto p-4  bg-clip-border shadow-3xl shadow-shadow-500  dark:!bg-navy-800  dark:!shadow-none bg-[#0B2447] text-white">
                <div class="relative flex h-20 w-full justify-center rounded-xl bg-cover" >
                    <div class="absolute bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full dark:!border-navy-700">
                        <img class="h-auto w-16 rounded-full" src='https://cdn-icons-png.flaticon.com/512/1177/1177491.png' alt="" />
                    </div>
                    <h4 class="text-xl mt-9  font-bold text-navy-700 text-white">
                        Twitter Clone
                    </h4>

                </div> 
                <div class=" flex flex-col items-center text-gray-200"> 
                    The project involves building a similar user interface, including features such as posting tweets, following other users, liking and retweeting posts, direct messaging, and exploring trending topics.
                </div> 
                <div className=' flex mt-3 justify-evenly'> 
                    <img src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png" className=' w-5 h-auto' alt="" />
                    <img src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png" alt="" className=' w-5 h-auto ml-3' />
                    <img src="https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg" alt="" className=' w-5 h-auto ml-3' />


                </div>  
                <button className=' bg-gradient-to-r from-cyan-500 to-blue-500 p-[3px] rounded-xl text-sm mt-3 w-[110px]'>Under Development</button> 
                
             
            </div>
        </div>
        </div>

    </div>
  )
}

export default Works